import React from 'react'
import s from './Faq.module.css'
import { Collapse, theme } from 'antd'
import plus from '../../assets/img/plus.svg'
import minus from '../../assets/img/minus.png'
import { motion } from 'framer-motion'
import Contact from '../contact/Contact'
import Hero from '../../components/hero/Hero'
import { useTranslation } from 'react-i18next'

const { Panel } = Collapse

const Faq = () => {
  const { token } = theme.useToken()
  const { t } = useTranslation()

  const faqItems = [
    {
      key: '1',
      titleKey: 'faq.faq1.title',
      textKey: 'faq.faq1.text',
    },
    {
      key: '2',
      titleKey: 'faq.faq2.title',
      textKey: 'faq.faq2.text',
    },
    {
      key: '4',
      titleKey: 'faq.faq3.title',
      textKey: 'faq.faq3.text',
    },
    {
      key: '5',
      titleKey: 'faq.faq4.title',
      textKey: 'faq.faq4.text',
    },
    {
      key: '6',
      titleKey: 'faq.faq5.title',
      textKey: 'faq.faq5.text',
    },
    {
      key: '7',
      titleKey: 'faq.faq6.title',
      textKey: 'faq.faq6.text',
    },
    {
      key: '8',
      titleKey: 'faq.faq7.title',
      textKey: 'faq.faq7.text',
    },
    {
      key: '9',
      titleKey: 'faq.faq8.title',
      textKey: 'faq.faq8.text',
    },
  ]

  return (
    <div className={s.wrapper}>
      <motion.div
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className={s.motion_div}
      >
        <div className={s.content}>
          <Hero 
            title_1={t('faq.hero.title')}
            description={t('faq.hero.description')}
          />
          <div className={s.collapse_block}>
            {faqItems.map(item => (
              <Collapse
                key={item.key}
                className={s.my_collapse}
                expandIconPosition={'end'}
                bordered={false}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <img className={s.icon_minus} src={minus} alt="" />
                  ) : (
                    <img src={plus} className={s.icon_plus} alt="" />
                  )
                }
                style={{
                  background: 'transparent',
                  alignItems: 'center',
                  transition: token.motionEaseInOut,
                }}
              >
                <Panel header={t(item.titleKey)} key={item.key} className={s.panelStyle}>
                  <div className={s.collapse_text}>
                    <p className={s.answer}>{t(item.textKey)}</p>
                  </div>
                </Panel>
              </Collapse>
            ))}
          </div>
        </div>
        <Contact />
      </motion.div>
    </div>
  )
}

export default Faq;
